import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Grid, Card, CardContent, CardMedia, Typography, Button, TextField, InputAdornment, Select, MenuItem, FormControl, InputLabel, Box, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';

const Ads = () => {
    const [ads, setAds] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [adSize, setAdSize] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAds = async () => {
            try {
                const response = await axios.get('https://api.typecopy.co.za/api/Ads');
                setAds(response.data);
            } catch (error) {
                console.error('Error fetching ads:', error);
            }
        };

        fetchAds();
    }, []);

    const handleAdClick = (id) => {
        navigate(`/ads/${id}`);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleAdSizeChange = (event) => {
        setAdSize(event.target.value);
    };

    const handleSortOrderChange = (event) => {
        setSortOrder(event.target.value);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const getAdSize = (copyCount) => {
        if (copyCount < 100) {
            return 'small';
        } else if (copyCount < 500) {
            return 'medium';
        } else {
            return 'large';
        }
    };

    const filteredAds = ads
        .filter((ad) =>
            ad.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            ad.niche.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .filter((ad) => (adSize ? getAdSize(ad.copyCount) === adSize : true))
        .sort((a, b) => {
            if (sortOrder === 'asc') {
                return a.title.localeCompare(b.title);
            } else if (sortOrder === 'desc') {
                return b.title.localeCompare(a.title);
            }
            return 0;
        });

    const adsPerPage = 9;
    const paginatedAds = filteredAds.slice((page - 1) * adsPerPage, page * adsPerPage);
    const pageCount = Math.ceil(filteredAds.length / adsPerPage);

    return (
        <Box sx={{ width: '100%', padding: 2 }}>
            <Typography variant="h4" gutterBottom align="center">
                Ads
            </Typography>
            <Typography variant="body1" gutterBottom align="center">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 4, mb: 4 }}>
                {/* Filters next to each other */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                    <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Ad Size</InputLabel>
                        <Select
                            value={adSize}
                            onChange={handleAdSizeChange}
                            label="Ad Size"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            <MenuItem value="small">Small</MenuItem>
                            <MenuItem value="medium">Medium</MenuItem>
                            <MenuItem value="large">Large</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Sort Order</InputLabel>
                        <Select
                            value={sortOrder}
                            onChange={handleSortOrderChange}
                            label="Sort Order"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            <MenuItem value="asc">Alphabetically (A-Z)</MenuItem>
                            <MenuItem value="desc">Alphabetically (Z-A)</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* Search on the right */}
                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search Ads"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ minWidth: 300 }}
                    />
                </Box>
            </Box>
            <Grid container spacing={4}>
                {paginatedAds.map((ad) => (
                    <Grid item key={ad.id} xs={12} sm={6} md={4}>
                        <Card>
                            <CardMedia
                                component="img"
                                height="140"
                                image={ad.imageUrl}
                                alt={ad.title}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {ad.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {ad.niche}
                                </Typography>
                                <Typography variant="body2" color="text.primary" sx={{ whiteSpace: 'pre-wrap' }}>
                                    {ad.content}
                                </Typography>
                                <Button variant="contained" color="primary" onClick={() => handleAdClick(ad.id)}>
                                    View Ad
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Pagination count={pageCount} page={page} onChange={handlePageChange} color="primary" />
            </Box>
        </Box>
    );
};

export default Ads;